import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography
} from '@mui/material';
import { ConnectBusinessProfileModalCss, LocalSeoAllSx } from './localSeoCss';

export const LocalSeoCommonLoader = ({ isNodata = null, message = null }) => {
  return (
    <>
      <Card
        className="LocalSeoCommonLoader"
        sx={ConnectBusinessProfileModalCss?.cardSx}
      >
        <CardContent>
          <Box sx={LocalSeoAllSx?.localSeoLoader}>
            {isNodata ? (
              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  fontSize: 'var(--font-size-16)',
                  lineHeight: 'var(--line-height-22)',
                  textAlign: 'center',
                  color: 'var(--color-text-secondary)'
                }}
              >
                {message ? message : 'No Business Details Found'}
              </Typography>
            ) : (
              <CircularProgress size={44} />
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
